<template>
  <icon type="md-list-box" size="24" color="#7F92A9" />
</template>

<script>
  export default {};
</script>

<style scoped></style>
